import React, { useState, useEffect } from "react";
import classes from "./CashMovementsModal.module.css";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { BASE_URL } from '../../../Components/Styles/API/API';
import Swal from "sweetalert2";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";
import { Modal } from 'react-bootstrap';
import Select from "react-select";
import { useNavigate } from "react-router-dom";

function CashMovementsModal({ isOpen, onClose,fetchData }) {
  const [journalRows, setJournalRows] = useState([
    { account: null, account_id: "", account_code: "", description: "", direction: "", amount: "", showDropdown: false }
  ]);
    const [selectedCurrency, setSelectedCurrency] = useState("");
    const [currencyOptions, setCurrencyOptions] = useState([]);
      const [bearer, setBearer] = useState('');
  const [reference, setReference] = useState("");
  const [loadingRef, setLoadingRef] = useState(false);
  const [transactionDate, setTransactionDate] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
    const navigate = useNavigate();
     const [selectedOptions, setSelectedOptions] = useState([]);
const [tableDatas, setTableDatas] = useState([]);
 const [formData, setFormData] = useState([{ sn: 1, accountFrom: '',  accountTo: '', amount: '', description: '', }]);
 const [selectOptions, setSelectOptions] = useState([]);
 const [selectedOptions1, setSelectedOptions1] = useState([]);
 const [load, setLoad] = useState(false);
  const handlePrinter = () => window.print();

     const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${bearer}`
    };

     const readData = async () => {
          try {
            const value = await localStorage.getItem('userToken');
            const value1 = await localStorage.getItem('tobi');
             const current = await localStorage.getItem('currentMonth');
      
      
            if (value !== null && value.trim() !== '') {
              setBearer(value);
            }
             if (current !== null) {
          console.log(current)
          const date = new Date(current);  // Assume current is in a parsable date format
  
          // setCurrentMonth(date);
          const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
          const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          // Set the min and max date for the date input
  
          const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');  // Add leading zero
            const day = String(date.getDate()).padStart(2, '0');         // Add leading zero
            return `${year}-${month}-${day}`;
        };
          
         
  
         console.log(formatDate(startOfMonth), formatDate(endOfMonth));
  
        }
             else {
              navigate('/login');
              return;
            }
  
      
          } catch (e) {
            alert('Failed to fetch the input from storage');
          }
        };
      
        useEffect(() => {
          readData();
        }, []);
    

  useEffect(() => {
    const fetchReference = async () => {
      console.log('in the Tokennssss');
      const token = localStorage.getItem("userToken");
      if (!token) return;
      setLoadingRef(true);
      try {
        const res = await axios.get(`${BASE_URL}/generate-sales-invoice-code`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        if (res?.data) {
          const payload = res.data;
          const d =
            payload?.data ??
            payload?.code ??
            payload?.reference ??
            payload?.number ??
            payload?.data?.code;
          let ref = "";
          if (typeof d === "string" || typeof d === "number") {
            ref = d;
          } else if (d && typeof d === "object") {
            ref = d.code || d.reference || d.number || "";
          }
          setReference(ref ? String(ref) : "");
        }
      } catch (error) {
        console.error("Error fetching journal reference:", error);
      } finally {
        setLoadingRef(false);
      }
    };

    if (isOpen) {
      fetchReference();
    }
  }, [isOpen]);

  useEffect(() => {
    const fetchAccounts = async () => {
      const token = localStorage.getItem("userToken");
      if (!token) return;
      setAccountsLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/account`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const payload = res?.data;
        let raw = payload?.data ?? payload;
        if (raw && typeof raw === "object" && Array.isArray(raw.data)) {
          raw = raw.data;
        }
        const list = Array.isArray(raw) ? raw : [];
        setAccounts(list);
      } catch (err) {
        console.error("Error fetching accounts:", err);
        setAccounts([]);
      } finally {
        setAccountsLoading(false);
      }
    };

    if (isOpen) {
      fetchAccounts();
    }
  }, [isOpen]);

  const totalDebit = journalRows.reduce(
    (sum, r) => sum + (r.direction === "1" && parseFloat(r.amount) || 0),
    0
  );
  const totalCredit = journalRows.reduce(
    (sum, r) => sum + (r.direction === "2" && parseFloat(r.amount) || 0),
    0
  );
const addLine = () => {
  setFormData(prev => [
    ...prev,
    { accountFrom: null, accountTo: null, description: "", amount: "" },
  ]);
};

const removeRow = (index) => {
  setFormData(prev => prev.length > 1 ? prev.filter((_, i) => i !== index) : prev);
};


  const fetchCharts = async () => {
    
    try {
      const response = await axios.get(`${BASE_URL}/account`, { headers });
      const results = response.data?.data;
  
      const options = results.map((chart) => ({
        label: `${chart.gl_code} - ${chart.gl_name}`,
        value: chart.id,
      }));
      
  
      setTableDatas(results);
      setSelectOptions(options);
    } catch (error) {
      if (error.response && error.response.status === 401) {
  
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setSelectOptions([]);
      }
    } finally {
     
    }
  };
  
  
  useEffect(() => {
    if (bearer) {
      fetchCharts();
  
    }
  }, [bearer]);
  const duplicateRow = (index) => {
    setJournalRows(prev => {
      const newRows = [...prev];
      const emptyRow = { account: null, account_id: "", account_code: "", description: "", direction: "", amount: "", showDropdown: false };
      newRows.splice(index + 1, 0, emptyRow);
      return newRows;
    });
  };



 const handleChange = (index, field, value) => {
  setFormData(prev => {
    const newRows = [...prev];
    newRows[index][field] = value;
    return newRows;
  });
};



  const fetchCurrency = async () => {
       
        try {
            const response = await axios.get(`${BASE_URL}/fetch-all-currencies`, { headers });
            const results = response.data?.data;
            // console.log(results, "currencis")
            const options = results.map((item) => ({
                label: item.name || item.code,
                value: item.id,
                symbol: item.symbol
            }));
        
            setCurrencyOptions(options);
        } catch (error) {
            const errorStatus = error.response?.data?.message;
            console.log(errorStatus);
          
        } finally {
            
        }
    };

     useEffect(() => {
        if (bearer) {
          fetchCurrency();
        }
      }, [bearer]);

 const createJournal = async () => {
      const confirmed = await Swal.fire({
        title: 'Are you sure?',
        text: 'You are about to process this transaction.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, process it!',
        cancelButtonText: 'No, cancel',
      });
  
      if (!confirmed.isConfirmed) {
        return;
      }
      
      setLoad(true);
  
      try {
       const accountFrom = formData.map(row => row.accountFrom?.value).filter(v => v !== undefined);
const accountTo = formData.map(row => row.accountTo?.value).filter(v => v !== undefined);
const descriptions = formData.map(row => row.description);
const amounts = formData.map(row => row.amount);
        // const debitAmount = totalAmountDebit.replace(/,/g, '').replace(/\.00$/, '');
  
  
  
        // console.log(accountNames, creditAmount, debitAmount, descriptions, amounts, directions, "information")
        const response = await axios.post(`${BASE_URL}/cash_movement/create`,
          {
           transaction_date: transactionDate,
           from: accountFrom,
           to: accountTo,
           description: descriptions,
           amount: amounts
          },
          { headers }
        );
      
  
       Swal.fire({
  icon: 'success',
  title: 'Successful',
  text: response.data.message,
}).then(() => {
  fetchData();
  onClose();
  setFormData([])
});

      } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
          
            console.log(errorMessage);
          }
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
        //   console.log(error);
      } finally {
        setLoad(false);
      }
    };

  if (!isOpen) return null;

const handleFormChange = (index, field, value) => {
  let formattedValue = value;

  // Format the amount field
  if (field === 'amount' && value !== '') {
    formattedValue = (Number(value.replace(/\D/g, '')) || '').toLocaleString();
  }

  const updatedFormData = [...formData];
  updatedFormData[index][field] = formattedValue;
  setFormData(updatedFormData);
};

const handleValueChange1 = (value, index) => {
  const updatedFormData = [...formData];
  updatedFormData[index] = {
    ...updatedFormData[index],
    amount: value,
  };
  setFormData(updatedFormData);
};


const handleAccountChange = (selectedOption, index) => {
  setFormData(prev => {
    const newRows = [...prev];
    newRows[index].accountFrom = selectedOption;

    // Also store province_balance for validation
    const account = tableDatas.find(acc => acc.id === selectedOption.value);
    newRows[index].province_balance = parseFloat(account.province_balance);

    // Reset any previous error
    newRows[index].error = "";
    return newRows;
  });
};
const validateAmount = (row) => {
  const amount = parseFloat(row.amount);
  const balance = parseFloat(row.province_balance ?? 0);

  if (balance < 0) {
    Swal.fire({
      icon: "error",
      title: "Invalid Account",
      text: "Insufficient balance",
      confirmButtonColor: "#3085d6",
    });
    return false;
  }

  if (amount > balance) {
    Swal.fire({
      icon: "error",
      title: "Invalid Amount",
      text: `Insufficient balance`,
      confirmButtonColor: "#3085d6",
    });
    return false;
  }

  return true;
};




const handleAccountChange1 = (selectedOption, index) => {
  setFormData(prev => {
    const newRows = [...prev];
    newRows[index].accountTo = selectedOption;
    return newRows;
  });
};

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size={null}
      backdropClassName={classes.modalBackdrop}
      dialogClassName={classes.modalDialog}
      contentClassName={classes.modalContent}
    >
      <h3 className={classes.title}>Cash Movement</h3>
      <p className={classes.subtitle}>
        Add multiple movement lines.
      </p>

      <div className={classes.topRow}>
       <div className={classes.inputGroup}>
          <label>Reference</label>
          <div className={classes.refContainer}>
            {loadingRef ? (
              <div className={classes.spinnerWrapper}>
                <Spinner animation="border" size="sm" />
              </div>
            ) : (
              <input
                type="text"
                value={reference}
                readOnly
                placeholder="Fetching reference..."
              />
            )}
          </div>
        </div>
        <div className={classes.inputGroup}>
          <label>Transaction Date</label>
          <input
            type="date"
            value={transactionDate}
            onChange={e => setTransactionDate(e.target.value)}
            required
          />
        </div>
        <div className={classes.inputGroup}>
                 <label>Currency</label>
                <Select
                            value={
                              selectedCurrency
                                ? currencyOptions.find((option) => option.value === selectedCurrency)
                                : null
                            }
                            onChange={(selectedOption) => setSelectedCurrency(selectedOption?.value || "")}
                            options={currencyOptions}
                            placeholder="Currency"
                            isClearable
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: "32px",
                                height: "32px",
                                fontSize: "12px",
                                borderColor: "#ccc",
                                boxShadow: "none",
                                "&:hover": { borderColor: "#999" },
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                height: "32px",
                                padding: "0 6px",
                              }),
                              input: (base) => ({
                                ...base,
                                margin: 0,
                                padding: 0,
                              }),
                              indicatorsContainer: (base) => ({
                                ...base,
                                height: "32px",
                              }),
                              placeholder: (base) => ({
                                ...base,
                                fontSize: "13px",
                                color: "#888",
                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: "12px",
                              }),
                            }}
                          />
               </div>
      </div>

<table className={classes.table}>
  <thead>
    <tr>
      <th style={{ width: "200px" }}>From Account</th>
      <th style={{ width: "200px" }}>To Account</th>
      <th style={{ width: "380px" }}>Description</th>
      <th style={{ width: "180px" }}>Amount</th>
      <th style={{ width: "100px" }}>Actions</th>
    </tr>
  </thead>
  <tbody>
   {formData.map((row, index) => (
  <tr key={index} style={{ height: "50px" }}>
    {/* --- From Account --- */}
    <td className={classes.accountCell} style={{ width: "340px" }}>
      <div className={classes.searchableDropdown}>
        <Select
          value={row.accountFrom}
          onChange={(opt) => handleAccountChange(opt, index)}
          options={selectOptions}
          menuPortalTarget={document.body}
          menuPosition="fixed"
            styles={{
         control: (base) => ({
                  ...base,
                  minHeight: "40px",
                  height: "40px",
                  fontSize: "14px",
                  borderColor: "#ccc",
                  borderRadius: "6px",
                  boxShadow: "none",
                  "&:hover": { borderColor: "#999" },
                  textAlign: "left",
                }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
             menu: (base) => ({
                  ...base,
                  fontSize: "13px",
                  zIndex: 20,
                  textAlign: "left",
                }),
                dropdownIndicator: (base) => ({
                  ...base,
                  padding: "4px",
                }),
                clearIndicator: (base) => ({
                  ...base,
                  padding: "4px",
                }),
          }}
        />
      </div>
    </td>

    {/* --- To Account --- */}
    <td className={classes.accountCell} style={{ width: "340px" }}>
      <div className={classes.searchableDropdown}>
        <Select
          value={row.accountTo}
          onChange={(opt) => handleAccountChange1(opt, index)}
          options={selectOptions}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={{
         control: (base) => ({
                  ...base,
                  minHeight: "40px",
                  height: "40px",
                  fontSize: "14px",
                  borderColor: "#ccc",
                  borderRadius: "6px",
                  boxShadow: "none",
                  "&:hover": { borderColor: "#999" },
                  textAlign: "left",
                }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
             menu: (base) => ({
                  ...base,
                  fontSize: "13px",
                  zIndex: 20,
                  textAlign: "left",
                }),
                dropdownIndicator: (base) => ({
                  ...base,
                  padding: "4px",
                }),
                clearIndicator: (base) => ({
                  ...base,
                  padding: "4px",
                }),
          }}
        />
      </div>
    </td>

    {/* --- Description --- */}
    <td style={{ width: "380px" }}>
      <input
        type="text"
        value={row.description}
        onChange={(e) => handleChange(index, "description", e.target.value)}
        placeholder="Narration / description"
        style={{
          width: "100%",
          height: "40px",
          padding: "6px 10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          boxSizing: "border-box",
        }}
      />
    </td>

    {/* --- Amount --- */}
    <td style={{ width: "180px" }}>
   <input
  type="number"
  value={row.amount}
  onChange={(e) => handleChange(index, "amount", e.target.value)}
  onBlur={() => validateAmount(row)}
  style={{
    width: "100%",
    height: "40px",
    padding: "6px 10px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    textAlign: "right",
    boxSizing: "border-box",
  }}
/>


{/* Display error message */}
{row.error && (
  <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
    {row.error}
  </div>
)}

    </td>

    {/* --- Actions --- */}
    <td className={classes.actionsCell} style={{ width: "100px" }}>
      <button onClick={() => removeRow(index)} className={classes.removeBtn}>
        Remove
      </button>
    </td>
  </tr>
))}

  </tbody>
</table>



      <div className={classes.actionRow}>
        <button className={classes.addLineBtn} onClick={addLine}>
          + Add Line
        </button>
      </div>

    
      <div className={classes.footerButtons}>
        <button
          className={classes.resetBtn}
          onClick={() =>
            setJournalRows([
              { account: null, account_id: "", account_code: "", description: "", direction: "", amount: "", showDropdown: false }
            ])
          }
        >
          Reset
        </button>
        <button className={classes.printBtn} onClick={handlePrinter}>Print</button>
        <button
          className={classes.submitBtn}
          onClick={createJournal}
          disabled={isSaving}
        >
          {load ? (
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <Spinner animation="border" size="sm" />
              Saving...
            </span>
          ) : (
            "Submit"
          )}
        </button>
      </div>

      <button className={classes.closeBtn} onClick={onClose}>
        ×
      </button>
    </Modal>
  );
}

export default CashMovementsModal;
